import React, { useState } from 'react';
import { IconButton, Typography, Box, Stack } from '@mui/material';
import { ArrowBackIosNew, ArrowForwardIos } from '@mui/icons-material';

const carouselData = [
    {
        title: "Proposal Automation",
        description:
            "Turn early-stage design data into full proposals—automatically. With one set of inputs, generate accurate, 3D models, 2D drawings, cost estimates, and man-hour breakdowns in minutes. Fast, accurate proposals—ready to win the job.",
        videoUrl: "/videos/Proposal_Automation.mp4",
    },
    {
        title: "Detailed Engineering Automation",
        description:
            "From input to issue-ready drawings—automatically. With a single design input, generate calculations, 3D models, detailed 2D drawings with Bill of Materials, fabrication sheets, and design reports in an instant. Fast, consistent outputs—ready for fabrication and review. ",
        videoUrl: "/videos/Engineering_Automation.mp4",
    },
    {
        title: "Validation",
        description:
            "Validate drawings, models, and data—instantly. Automatically compare revisions, detect changes, highlight inconsistencies, and flag missing deliverables across 2D, 3D, and tabular outputs. No more manual cross- checking—just fast, reliable validation. ",
        videoUrl: "/videos/validation.mp4",
    },
    {
        title: "Material Control System",
        description: "Track materials with precision—every step of the way. Automate requests, approvals, and deliveries while monitoring stock levels, supplier performance, and material usage across projects. Stay ahead of delays and shortages—with full visibility and control. ",
        videoUrl: "videos/material_control_system.mp4",
    },
    {
        title: "Document Control System",
        description: "Control documents with confidence—from creation to approval. Automatically manage revisions, route documents through review cycles, and track approval status across stakeholders. Forget version chaos—ensure everyone’s working with the latest files, every time. ",
        videoUrl: "videos/document_control_system.mp4",
    },
    {
        title: "Project Control System",
        description: "Keep every task on track—at every stage. Organize fabrication, ITP, and other critical tasks into structured workflows—assign responsibilities, set deadlines, and monitor progress in real time. No more missed steps—just streamlined task management from start to finish. ",
        videoUrl: "videos/project_control_system.mp4",
    },
    {
        title: "Project Management System",
        description: "Manage your projects smarter—with time and cost in focus. Visualize your schedule and budget in one place, comparing estimates to actual data as work progresses. No more surprises—just smarter decisions, backed by real-time insights. ",
        videoUrl: "videos/project_management_system.mp4",
    },
];

const FeatureCarousel = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const currentSlide = carouselData[currentIndex];

    const handleNext = () => {
        if (currentIndex < carouselData.length - 1) setCurrentIndex(currentIndex + 1);
    };

    const handlePrev = () => {
        if (currentIndex > 0) setCurrentIndex(currentIndex - 1);
    };

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                bgcolor: '#111111',
                px: 4,
                color: 'white',
                fontFamily: '"Darker Grotesque", sans-serif',
                id: "feature-carousel",
            }}
        >
            {/* Left Arrow */}
            <IconButton onClick={handlePrev} disabled={currentIndex === 0} sx={{ color: 'white', pr: 2 }}>
                <ArrowBackIosNew />
            </IconButton>

            {/* Content */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', maxWidth: '1600px' }}>

                {/* Text Section */}
                <Stack sx={{
                    flex: 1, pr: 4, gap: 3,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                }}>
                    <Typography variant="overline" sx={{ fontSize: '25px', color: 'gray', pb: 7, fontFamily: "inherit" }}>
                        FEATURE SPOTLIGHT
                    </Typography>
                    <Typography sx={{ color: '#A259FF', fontSize: '50px', fontWeight: 'bold', fontFamily: "inherit" }}>
                        {currentSlide.title}
                    </Typography>
                    <Typography sx={{ mt: 2, fontSize: '26px', maxWidth: '90%', fontFamily: "inherit" }}>
                        {currentSlide.description}
                    </Typography>
                </Stack>

                {/* Video Section */}
                <Box
                    sx={{
                        flex: 1,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        aspectRatio: '1 / 1',
                        maxWidth: '800px',
                    }}
                >
                    <video
                        src={currentSlide.videoUrl}
                        autoPlay
                        loop
                        muted
                        playsInline
                        style={{ width: '100%', height: '100%', borderRadius: '12px', objectFit: 'cover' }}
                    />
                </Box>
            </Box>

            {/* Right Arrow */}
            <IconButton onClick={handleNext} disabled={currentIndex === carouselData.length - 1} sx={{ color: 'white' }}>
                <ArrowForwardIos />
            </IconButton>
        </Box>
    );
};

export default FeatureCarousel;
